import type { ToolsProductCard } from "@/types/product";

import PC from "../../ProductCardTemplate";
import config from "../../config";

const { Card, Gallery, Content, Description, Price, Name, Tags } = PC;

const ToolProductCard = ({ data }: { data: ToolsProductCard }) => {
  if (!data) return null;

  const { core, description, gallery } = data;

  return (
    <Card name={core?.name ?? ""} slug={config.slugs.tools + core?.slug}>
      <Gallery
        url={gallery?.image?.uri ?? ""}
        alt={gallery?.image?.alt ?? ""}
        secondImage={gallery?.secondImage}
      >
        <Tags activeTag={gallery?.activeTag} />
      </Gallery>
      <Content>
        <Description>
          <Name>{description?.name ?? ""}</Name>
        </Description>

        <Price
          price={description?.price}
          priceBeforeDiscount={description?.priceBeforeDiscount}
        />
      </Content>
    </Card>
  );
};

export default ToolProductCard;
